export const SONGS = [
  { label: 'All', value: 'ALL' },
  { label: 'Admin', value: 'ADMIN' },
  { label: 'Artist', value: 'ARTIST' },
];

export const GENRE = [
  { label: 'Afrobeat', value: 'Afrobeat' },
  { label: 'Afropop', value: 'Afropop' },
  { label: 'Alternative', value: 'Alternative' },
  { label: 'Big Band', value: 'Big Band' },
  { label: 'Big Room', value: 'Big Room' },
  { label: 'Blues', value: 'Blues' },
  { label: 'Breaks', value: 'Breaks' },
  { label: 'Chill Out', value: 'Chill Out' },
  { label: "Children's Music", value: "Children's Music" },
  { label: 'Christian / Gospel', value: 'Christian / Gospel' },
  { label: 'Classical', value: 'Classical' },
  { label: 'Comedy', value: 'Comedy' },
  { label: 'Country', value: 'Country' },
  { label: 'Dance', value: 'Dance' },
  { label: 'Deep House', value: 'Deep House' },
  { label: 'Drum & Bass', value: 'Drum & Bass' },
  { label: 'Dubstep', value: 'Dubstep' },
  { label: 'Electro House', value: 'Electro House' },
  { label: 'Electronic', value: 'Electronic' },
  { label: 'Electronica / Downtempo', value: 'Electronica / Downtempo' },
  { label: 'Fitness & Workout', value: 'Fitness & Workout' },
  { label: 'Folk', value: 'Folk' },
  { label: 'French Pop', value: 'French Pop' },
  { label: 'Funk / Soul / Disco', value: 'Funk / Soul / Disco' },
  { label: 'German Folk', value: 'German Folk' },
  { label: 'German Pop', value: 'German Pop' },
  { label: 'Glitch Hop', value: 'Glitch Hop' },
  { label: 'Hard Dance', value: 'Hard Dance' },
  { label: 'Hardcore / Hard Techno', value: 'Hardcore / Hard Techno' },
  { label: 'Hip Hop/Rap', value: 'Hip Hop/Rap' },
  { label: 'Hip-Hop / R&B', value: 'Hip-Hop / R&B' },
  { label: 'Holiday', value: 'Holiday' },
  { label: 'House', value: 'House' },
  { label: 'Indie Dance / Nu Disco', value: 'Indie Dance / Nu Disco' },
  { label: 'J-Pop', value: 'J-Pop' },
  { label: 'Jazz', value: 'Jazz' },
  { label: 'K-Pop', value: 'K-Pop' },
  { label: 'Latin', value: 'Latin' },
  { label: 'Latin Urban', value: 'Latin Urban' },
  { label: 'Metal', value: 'Metal' },
  { label: 'Minimal / Deep Tech', value: 'Minimal / Deep Tech' },
  { label: 'New Age', value: 'New Age' },
  { label: 'Pop', value: 'Pop' },
  { label: 'Progressive House', value: 'Progressive House' },
  { label: 'Psy-Trance', value: 'Psy-Trance' },
  { label: 'Punk', value: 'Punk' },
  { label: 'R&B/Soul', value: 'R&B/Soul' },
  { label: 'Reggae', value: 'Reggae' },
  { label: 'Reggae / Dancehall / Dub', value: 'Reggae / Dancehall / Dub' },
  { label: 'Rock', value: 'Rock' },
  { label: 'Singer/Songwriter', value: 'Singer/Songwriter' },
  { label: 'Soundtrack', value: 'Soundtrack' },
  { label: 'Spoken Word', value: 'Spoken Word' },
  { label: 'Tech House', value: 'Tech House' },
  { label: 'Techno', value: 'Techno' },
  { label: 'Trance', value: 'Trance' },
  { label: 'Vocal', value: 'Vocal' },
  { label: 'World', value: 'World' },
];
export const USERS = [
  { label: 'All', value: 'ALL' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Block', value: 'BLOCKED' },
];

